export { default, LlegendaEleccionsDades } from './LlegendaEleccions';
